let recommend_data = [
    { 
        imgUrl: '/img/recommend1.jpg', 
        imgUrl2: '/img/recommend1_sub.jpg',
        name: '오크먼트 TR v3',
        price: 89000
    },
    { 
        imgUrl: '/img/recommend2.jpg' , 
        imgUrl2: '/img/recommend2_sub.jpg',
        name: '오크먼트 TR v3',
        price: 89000
    },
    { 
        imgUrl: '/img/recommend3.jpg', 
        imgUrl2: '/img/recommend3_sub.jpg',
        name: '오크먼트 TR v3',
        price: 89000 
    },
    { 
        imgUrl: '/img/recommend4.jpg', 
        imgUrl2: '/img/recommend1_sub.jpg',
        name: '오크먼트 TR v3',
        price: 119000 
    },
    { 
        imgUrl: '/img/recommend5.jpg', 
        imgUrl2: '/img/recommend5_sub.jpg',
        name: '오크먼트 TR 다이얼 v2',
        price: 119000 
    },
    { 
        imgUrl: '/img/recommend6.jpg', 
        imgUrl2: '/img/recommend6_sub.jpg',
        name: '오크먼트 TR 다이얼 v2',
        price: 119000 
    },
    { 
        imgUrl: '/img/recommend7.jpg', 
        imgUrl2: '/img/recommend7_sub.jpg',
        name: '오크먼트 TR v2',
        price: 79000 
    },
    { 
        imgUrl: '/img/recommend8.jpg', 
        imgUrl2: '/img/recommend8_sub.jpg',
        name: '오크먼트 TR v2',
        price: 79000 
    }
]

export default recommend_data;